import api from "./api";

const endpoint = "tickets";

export class heartbeatService {
  static async send(ticketId: number | string) {
    const url = `${endpoint}/${ticketId}/heartbeat`;

    return api.put(url);
  }
}
